import React, { useCallback, useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Heart } from 'lucide-react';
interface Notification {
  id: number;
  name: string;
  location: string;
  action: string;
  timeAgo: string;
}
const names = ['María', 'Juan', 'Ana', 'Carlos', 'Sofía', 'Luis', 'Elena', 'Pablo'];
const locations = ['México', 'Colombia', 'España', 'Argentina', 'Chile', 'USA', 'Perú'];
const actions = ['descargó la guía', 'comenzó su Día 1', 'se unió al reto'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function LiveActivityPopup() {
  const [notification, setNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const showNotif = () => {
      setNotification({
        id: Date.now(),
        name: getRandomItem(names),
        location: getRandomItem(locations),
        action: getRandomItem(actions),
        timeAgo: 'hace un momento'
      });
      setTimeout(() => setNotification(null), 4000);
    };
    const interval = setInterval(showNotif, 12000);
    setTimeout(showNotif, 3000); // First one
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-4 left-4 z-40 max-w-[280px]" data-id="element-254">
      <AnimatePresence data-id="element-255">
        {notification && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} className="bg-[var(--bg-card)] rounded-lg p-3 shadow-lg flex items-center gap-3 border border-[var(--border-subtle)]" data-id="element-256">
            <div className="w-8 h-8 rounded-full bg-[var(--accent-soft)] flex items-center justify-center flex-shrink-0 text-[var(--accent)]" data-id="element-257">
              <Heart className="w-4 h-4 fill-current" data-id="element-258" />
            </div>
            <div data-id="element-259">
              <p className="text-xs text-[var(--text-heading)]" data-id="element-260">
                <span className="font-bold" data-id="element-261">{notification.name}</span> de{' '}
                {notification.location}
              </p>
              <p className="text-[10px] text-[var(--text-muted)]" data-id="element-262">
                {notification.action} • {notification.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}